import { render, staticRenderFns } from "./EmployeePlanYearContributions.vue?vue&type=template&id=bb5e2174&scoped=true"
import script from "./EmployeePlanYearContributions.vue?vue&type=script&lang=ts"
export * from "./EmployeePlanYearContributions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5e2174",
  null
  
)

export default component.exports